import type { MembershipProduct } from "../SpaceType";

/** 购买/订阅引导海报：移动端优先，其次 WEB */
export function resolveProductPosterUrl(
  row: Pick<MembershipProduct, "webPurchasePosterUrl" | "mobilePurchasePosterUrl">
): string {
  return (
    (row.mobilePurchasePosterUrl ?? "").trim() ||
    (row.webPurchasePosterUrl ?? "").trim()
  );
}
